import { api } from './client'

export interface StudentListItem {
  id: string
  classId: string
  className: string | null
  gradeLevel: number | null
  lastName: string
  firstName: string
  middleName: string | null
  fullName: string
}

export interface GradeSummary {
  date: string
  value: string
  type: string | null
  subjectId: string | null
  comment: string | null
}

export interface BehaviorSummary {
  date: string
  points: number
  categoryName: string | null
}

export interface AttendanceSummary {
  date: string
  status: string
  reason: string | null
}

export interface StudentContext {
  student: StudentListItem
  grades: GradeSummary[]
  behavior: BehaviorSummary[]
  behaviorTotal: number
  attendance: AttendanceSummary[]
  presentDaysPercent: number | null
}

export type AlertSeverity = 'LOW' | 'MEDIUM' | 'HIGH'

export interface StudentAlert {
  reason: 'low_grades' | 'behavior' | 'absences'
  message: string
  severity: AlertSeverity
  value: string
}

export interface AtRiskStudent {
  studentId: string
  classId: string
  className: string | null
  fullName: string
  alerts: StudentAlert[]
}

export interface AtRiskResponse {
  students: AtRiskStudent[]
  computedAt: number
  periodDays: number
}

export const studentsApi = {
  list: () => api<StudentListItem[]>('/students'),
  context: (id: string, subjectId?: string) => {
    const qs = subjectId ? `?subjectId=${encodeURIComponent(subjectId)}` : ''
    return api<StudentContext>(`/students/${encodeURIComponent(id)}/context${qs}`)
  },
  atRisk: (days = 30) => api<AtRiskResponse>(`/students/at-risk?days=${days}`),
}
